<div id="layout" class="sign_in f_col">
  <app-view-title fromRoute="document-management" [chooseLangBtn]="false">{{'documentManagement.title' | translate}}</app-view-title>
  <div class="scroll_wrapper resp_wrapper">

    <div class="resp_scroll-wrapper_l resp_c-50">
      <app-view-deco-image imageUrl="assets-projects/images/image_document.svg"></app-view-deco-image>
      <div class="flex f_col fullWidth gap_10">
        <div *ngFor="let document of allDocuments()" >
          <app-slide-element *ngIf="document.id !== 'embassypasszar'" leftIcon="passport" (btnClicked)="onClick(DocumentType[convertUppercase(document.id)])">
            {{convertUppercase(document.id).toLowerCase() | translate}}
          </app-slide-element>
        </div>
      </div>

      <div class="resp_minSize_l mb_20 mt_20 flex gap_10">
        <app-button size="xsm" color="transparent" border="true" class="fullWidth" (btnClicked)="nav.to('dashboard')">
          {{'global.back' | translate}}
        </app-button>
      </div>
    </div>
  </div>

  <div class="f_align_end mb_20 resp_maxSize_l">
    <app-back-btn class="mr_10" icon="house" [navTo]="{route: 'dashboard'}"></app-back-btn>
    <app-back-btn (btnClicked)="nav.to('dashboard')"></app-back-btn>
  </div>
</div>
